module.exports = __webpack_public_path__ + "r-v3/img/ml_04_00_over.3bed7010.jpg";